import * as React from 'react';

import type { InstructorsDataContextValue } from './InstructorsDataContext.types';

import { InstructorsDataContext } from './InstructorsDataProvider';

export function useInstructorsData(): InstructorsDataContextValue {
  const context = React.useContext(InstructorsDataContext);

  if (!context) {
    throw new Error(
      'useInstructorsData must be used within InstructorsDataProvider'
    );
  }

  return context;
}
